/**
 * 课程学习记录
 */

import {
  post
} from '@/util/request'

/**
 * 分页获取课程学习记录
 * @param {*} data
 * @returns
 */
export const GetDataCourseRecordList = (data) => {
  return post('/api/app/course/getLearningRecord', data, {});
}